var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="register_empty"> <div id="price_submenu"> <section class="page-info-block"> <div class="container"> <div class="page-info clearfix"> <ol class="breadcrumb pull-left"> <li><a href="#Index"><i class="fa fa-home"></i></a></li> <li class="active">'+
((__t=( resources['X100601'] ))==null?'':__t)+
'</li> <li class="active">'+
((__t=( resources['X100601'] ))==null?'':__t)+
'</li> </ol> </div> </div> </section> </div> <section class="content-block default-bg"> <div class="container" style="padding-top:30px;padding-bottom:30px"> <h4><i class="fa fa-user"></i>'+
((__t=( resources['X100691'] ))==null?'':__t)+
'</h4> <div class="control-group login_inputEmail"> <div class="form-group"> <label id="login_labelEmail" for="login_inputEmail">'+
((__t=( resources['X100692'] ))==null?'':__t)+
'</label> <input class="form-control" value="" id="login_inputEmail"> <span class="help-inline" style="color:red"></span> </div> </div> <div class="control-group login_inputPassword"> <div class="form-group"> <label id="login_labelPassword" for="login_inputPassword">'+
((__t=( resources['X100693'] ))==null?'':__t)+
'</label> <input class="form-control" value="" id="login_inputPassword"> <span class="help-inline" style="color:red"></span> </div> </div> <button type="button" class="btn btn-primary" id="login_btnSubmit">'+
((__t=( resources['X100691'] ))==null?'':__t)+
'</button> </div> </section> </div>';
}
return __p;
};
